import { Navigate, useRoutes } from 'react-router-dom';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { paths } from 'src/routes/paths';
import {
  PATH_ADMIN_AFTER_LOGIN,
  PATH_AGENT_AFTER_LOGIN,
  PATH_AUDITOR_AFTER_LOGIN,
  PATH_COFFEE_AFTER_LOGIN,
  PATH_CUSTOMER_AFTER_LOGIN,
} from 'src/config-global';
import {
  isLoggedIn,
  isRoleAdmin,
  isUserAgent,
  isUserAuditor,
  isUserCoffee,
} from 'src/utils/check-user-is-admin';
import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { publicRoutes } from './public';
import { adminRoutes } from './admin';
import { customerRoutes } from './customer';
import { downloadRoutes } from './downloads';
import { agentRoutes } from './agent';
import { auditorRoutes } from './auditor';
import { coffeeRoutes } from './coffee';

// ----------------------------------------------------------------------

export default function Router() {
  let indexPath = paths.login;

  if (isLoggedIn()) {
    if (isRoleAdmin()) {
      indexPath = PATH_ADMIN_AFTER_LOGIN;
    } else if (isUserAgent()) {
      indexPath = PATH_AGENT_AFTER_LOGIN;
    } else if (isUserAuditor()) {
      indexPath = PATH_AUDITOR_AFTER_LOGIN;
    } else if (isUserCoffee()) {
      indexPath = PATH_COFFEE_AFTER_LOGIN;
    } else {
      indexPath = PATH_CUSTOMER_AFTER_LOGIN;
    }
  }

  // NAT-2788 — the coffee role is confined to its one page. Its route table never mounts the
  // customer, agent, admin, auditor or download trees (it keeps main, for the 403 and 404 pages
  // only), so no provider of theirs (cart,
  // acting client) runs and no request fires before a guard could answer 403. isUserCoffee() reads
  // storage at render, like the index redirect above; Router re-renders on every navigation
  // (App subscribes to the location), and login and logout both navigate.
  const coffeeOnly = isUserCoffee();

  return useRoutes(
    coffeeOnly
      ? [
          { path: '/', element: <Navigate to={indexPath} replace /> },
          ...publicRoutes,
          ...mainRoutes,
          ...coffeeRoutes,
          { path: '*', element: <Navigate to={paths.coffee.dashboard} replace /> },
        ]
      : allRoutes(indexPath),
  );
}

const allRoutes = (indexPath: string) => [
  // SET INDEX PAGE WITH SKIP HOME PAGE
  {
    path: '/',
    element: <Navigate to={indexPath} replace />,
  },

  // ----------------------------------------------------------------------

  // public routes
  ...publicRoutes,

  // Auth routes
  ...authRoutes,

  // Customer routes
  ...customerRoutes,

  // Admin routes
  ...adminRoutes,

  // Main routes
  ...mainRoutes,

  // downloads
  ...downloadRoutes,

  // Agent routes
  ...agentRoutes,

  // Auditor routes
  ...auditorRoutes,

  // Coffee routes
  ...coffeeRoutes,

  // No match 404
  { path: '*', element: <Navigate to="/404" replace /> },
];
